import Link from "next/link";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

const PLATFORM_TERMS_URL = "https://www.attend.tech/terms-of-use";
const PLATFORM_PRIVACY_URL = "https://www.attend.tech/privacy-policy";

export const FAQS: TTeamConfig["LANGUAGES"]["FAQS"] = [
  {
    question: "What is the Winnipeg Jets Standby Club?",
    answer:
      "The Winnipeg Jets Standby Club is a purchased Subscription that gives you access to attend up to 7 specific home games in the month of November for one price of $165 per seat.",
  },
  {
    question: "Is a seat guaranteed for every game?",
    answer:
      "No. Seats are guaranteed only for select home games listed for November.",
  },
  {
    question: "How do I claim my tickets?",
    answer:
      "You will be notified by text when tickets are available to be claimed. If you indicate that you’re attending that game, you will receive a text message a few hours before the game confirming tickets are in your Jets 360 account.",
  },
  {
    question: "Do I need the Jets 360 App to participate?",
    answer:
      "Yes. You must use the official Winnipeg Jets App and have access to Jets 360 to manage tickets included in this offer.",
  },
  {
    question: "When will tickets become available to claim?",
    answer:
      "Tickets will be released 24 – 48 hours prior to eligible home games. Availability and release timing may vary by game, so be sure to check the Jets 360 App regularly for updates.",
  },
  {
    question: "How many games are included?",
    answer:
      "This offer includes access to 7 available home games in November. The exact number of games you can attend will depend on the games released and successfully claimed through the Jets 360 App.",
  },
  {
    question: "Are all home games included in this offer?",
    answer:
      "No. This offer applies only to eligible select home games in November. Game availability may vary, and some games may not be included in the offer.",
  },
  {
    question: "Can I transfer or share my claimed tickets?",
    answer:
      "Winnipeg Jets Standby Club Passes cannot be shared/forwarded to other parties. Admission into Canada Life Centre will be managed through the Jets 360 App and your mobile device.",
  },
  {
    question: "Can I sell my Standby tickets for games that I do not attend?",
    answer:
      "No. Standby Program tickets are non-transferable. Passes and Pass tickets cannot be resold. Violators will be removed from the program.",
  },
  {
    question: "Can I print my ticket?",
    answer:
      "No. Printed tickets and screenshots will not be accepted for entry into the game. Jets 360 app is required to use your tickets.",
  },
  {
    question: "What happens if I miss a claim window?",
    answer:
      "If you do not claim tickets during the available window, those seats may no longer be available.",
  },
  {
    question: "Who should I contact if I need help?",
    answer: (
      <>
        If you need assistance with app access, ticket claiming, or
        account-related questions, please contact{" "}
        <Link href="mailto:info@winnipegjets.com">info@winnipegjets.com</Link>.
      </>
    ),
  },
];

// New User Registration terms (auth page opt-in)
export const REGISTRATION_TERMS_AND_CONDITION = () => (
  <>
    By creating an account, you agree to receive account-related notification
    and marketing communication from the Winnipeg Jets and you confirm that you
    have read and agree to the platform&apos;s{" "}
    <Link target="_blank" href={PLATFORM_TERMS_URL}>
      Terms &amp; Conditions
    </Link>{" "}
    and{" "}
    <Link target="_blank" href={PLATFORM_PRIVACY_URL}>
      Privacy Policy
    </Link>
    .
  </>
);

// Checkout Purchase terms
export const TERMS_AND_CONDITION = () => (
  <>
    By checking the box you agree to receive notifications regarding your
    purchase and to the{" "}
    <Link target="_blank" href={PLATFORM_TERMS_URL}>
      Terms &amp; Conditions
    </Link>{" "}
    and{" "}
    <Link target="_blank" href={PLATFORM_PRIVACY_URL}>
      Privacy Policy
    </Link>
    .
  </>
);
